import "./discoverSkeleton.css";

export default function DiscoverSkeleton() {
	return (
		<div>
			{/* Optional: show the header skeleton too */}
			<div className="sf-skeleton-header"></div>

			<div className="sf-page">

				{/* Toolbar */}
				<div className="sf-skeleton-toolbar">
					<div className="sf-skeleton-btn"></div>
					<div className="sf-skeleton-btn"></div>
				</div>

				{/* Title */}
				<div className="sf-skeleton-title-block">
					<div className="sf-skeleton-line sf-skeleton-line-title"></div>
					<div className="sf-skeleton-line sf-skeleton-line-small"></div>
				</div>

				{/* Fake shop cards */}
				<section className="sf-skeleton-list">
					{Array.from({ length: 4 }).map((_, i) => (
						<article className="sf-skeleton-row" key={i}>
							{/* Image */}
							<div className="sf-skeleton-img"></div>

							{/* Text */}
							<div className="sf-skeleton-body">
								<div className="sf-skeleton-line sf-skeleton-line-med"></div>
								<div className="sf-skeleton-line sf-skeleton-line-short"></div>
								<div className="sf-skeleton-line sf-skeleton-line-tiny"></div>
							</div>
						</article>
					))}
				</section>
			</div>
		</div>
	);
}
